var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAktia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 404.9 128.8",
    style: {
      enableBackground: "new 0 0 404.9 128.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00A65D"
    },
    d: "M107.5,126.9L63.2,5H43.9L0,126.9h19L29.1,98h48.7l10.3,28.9H107.5L107.5,126.9z M72.2,81.6H34.6l9.7-27.8 c3.1-9,7.5-23,8.9-28.2c1.4,5.2,6.3,19.3,9.2,28L72.2,81.6L72.2,81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A65D"
    },
    d: "M200.5,126.9L173,66.1l23.1-30.6h-20.4l-19,26.6c-3,4.4-7.7,11.3-10.1,15c0-4.5,0.2-13.9,0.2-19.5V0L129,9.4 v117.5h17.9v-27l13.9-18.4l20.2,45.4H200.5L200.5,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A65D"
    },
    d: "M264.5,108.8c-3.3,1.9-8.5,3.7-13.2,3.7c-6.6,0-9.4-2.4-9.4-11V51.9h22.6V35.5h-22.6V0l-17.6,9.4v26.1h-13.1 v16.4h13.1v52.7c0,16.4,7.8,24.2,20.5,24.2c7.1,0,13.2-1.7,17.6-4.2L264.5,108.8L264.5,108.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00A65D"
    },
    d: "M310.3,12.2c0-6.4-5.2-11.7-11.5-11.7c-6.4,0-11.7,5.2-11.7,11.7c0,6.3,5.2,11.5,11.7,11.5 C305,23.7,310.3,18.4,310.3,12.2L310.3,12.2z M307.6,126.9V35.5h-17.9v91.4H307.6L307.6,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00A65D"
    },
    d: "M404.9,126.9V64.2c0-20.7-13.9-30.6-34.3-30.6c-12.9,0-22.6,2.8-31.3,8.2l7,13.6c7.1-4,14.4-5.7,23.8-5.7 c11.1,0,17.2,5.6,17.2,15.5v6.8c-5-2.3-11.8-3.5-20.4-3.5c-20.7,0-36.4,9.2-36.4,29.6c0,22.4,16.9,30.8,31.7,30.8 c9.9,0,18.8-4.7,25.1-11v9H404.9L404.9,126.9z M387.3,100.9c-4.2,5.7-12.5,11.7-22.1,11.7c-11.8,0-17.6-6.1-17.6-15.1 c0-8.4,7.3-13.6,18.8-13.6c9.7,0,16,1.6,20.9,4V100.9L387.3,100.9z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAktia);
export default __webpack_public_path__ + "static/media/aktia.e9fa9b45c4c31e985fe7bce248e3d91e.svg";
export { ForwardRef as ReactComponent };